import { render, staticRenderFns } from "./loginZaxis.vue?vue&type=template&id=185895c6&scoped=true&"
import script from "./loginZaxis.vue?vue&type=script&lang=js&"
export * from "./loginZaxis.vue?vue&type=script&lang=js&"
import style0 from "./loginZaxis.vue?vue&type=style&index=0&id=185895c6&lang=scss&scoped=true&"
import style1 from "./loginZaxis.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185895c6",
  null
  
)

export default component.exports